import { CommunicationEventReportResult } from './model/communication-event-report-result.model';
import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { timer } from 'rxjs';
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { QuestionHelpText } from 'src/app/model/question-help-text';
import { Region } from 'src/app/model/region.model';
import { Grade, School } from 'src/app/model/school.model';
import { PagingService } from 'src/app/service/paging.service';
import { MsgModel } from '../../common-components/msg/model/msg.model';
import { CommunicationEventReportService } from './service/communication-event-report.service';
import { CommunicationEventPurposeType } from './model/communication-event-purpose-type.model';
import moment from 'moment';
import { GetPropertyPipe } from 'src/app/pipes/get-property.pipe';
import { ApiExportsService } from 'src/app/service/api-exports.service';
import { UtilityService } from 'src/app/service/utility.service';
import { RegionDropdownComponent } from '../../common-components/region/region-dropdown/region-dropdown.component';
import { DistrictDropdownComponent } from '../../common-components/district/district-dropdown/district-dropdown.component';
import { ChosenRegion, ChosenSchoolDistrict } from '../counts/model/student-eligibility-count';
import { CountyDropdownComponent } from '../../common-components/county/county-dropdown/county-dropdown.component';
import { SchoolDropdownComponent } from '../../common-components/school/school-dropdown/school-dropdown.component';

@Component({
    selector: 'app-communication-event-report',
    templateUrl: './communication-event-report.component.html',
    styleUrls: ['./communication-event-report.component.scss']
})
export class CommunicationEventReportComponent implements OnInit {
    @ViewChildren(MatPaginator) paginators: QueryList<MatPaginator> = new QueryList<MatPaginator>();
    @ViewChildren(MatSort) sorts: QueryList<MatSort> = new QueryList<MatSort>();
    @ViewChild('appRegionCode') appRegionCode!: RegionDropdownComponent;
    @ViewChild('appCountyCode') appCountyCode!: CountyDropdownComponent;
    @ViewChild('appSchoolsCode') appSchoolsCode!: SchoolDropdownComponent;
    @ViewChild('appSchoolDistrictCode') appSchoolDistrictCode!: DistrictDropdownComponent;
    @Input() searchParm: any = [{}];

    // Search variables
    selectedSchoolYear: string = '';
    initialSchoolYear: string = '';
    currentSchoolYear: string = '';
    selectedPerformancePeriod: string = '';
    initialPerformancePeriod: string = '';
    currentPerformancePeriod: string = '';
    allRegions: Region[] = [];
    allDistricts: SchoolDistrict[] = [];
    lstSelectedRegion: Region[] = [];
    lstSelecteddistricts: SchoolDistrict[] = [];
    lstSelectedschools: School[] = [];
    chosenRegions: Region[] = [];
    chosenCounties: County[] = [];
    chosenSchoolDistricts: SchoolDistrict[] = [];
    chosenSchools: School[] = [];

    rAttending: boolean = false;
    rNotAttending: boolean = false;

    expiredEligibility: boolean = true;
    expiredQAD: boolean = true;
    noCommunicationEvent: boolean = false;

    grades: Grade[] = [];
    communicationTypes: CommunicationEventPurposeType[] = [];
    communicationEventPurposeTypes: CommunicationEventPurposeType[] = [];

    isExporting: boolean = false;
    hasExports: boolean = false;

    // Component variables
    resetField: boolean = false;

    lstchosenSchoolDistrict: ChosenSchoolDistrict[] = [];
    lstchosenSchoolRegion: ChosenRegion[] = [];
    lstCommunicationEventResponse: CommunicationEventReportResult[];
    strExportFileName = 'Communication_Events_Report';
    fileNameLabel: string = '';
    bCheckedStyling: boolean = true;

    // Table display
    baseDisplayedColumns: string[] = [
        'DISTRICT_NAME',
        'SCHOOL_NAME',
        'GRADE',
        'ENROLLMENT_TYPE',
        'MSD_NUMBER',
        'SSID',
        'PERSON.LAST_NAME',
        'DOB',
        'ELIGIBILITY_END_DATE',
        'DEPARTURE_DATE',
        'EIP_STATUS',
        'COMMUNICATION_TYPE',
        'COMMUNICATION_DATE',
        'RESIDENCY_VERIFIED'
    ];
    suffixColumns: string[] = [];
    displayedColumns: string[] = []; // Dynamically populated based on results + baseDisplayedColumns

    // Table results
    tableDataSource!: MatTableDataSource<CommunicationEventReportResult>;

    // Results
    results: CommunicationEventReportResult[] = [];
    filter: string = '';

    lstQuestionHelpText: QuestionHelpText[] = [];
    currentSetting: any;
    isLoading: boolean = false;
    msg: MsgModel = {};

    getPropertyPipe = new GetPropertyPipe();

    constructor(
        public pagingService: PagingService,
        private communicationEventReportService: CommunicationEventReportService,
        private apiMsinExportsService: ApiExportsService,
        private utilityService: UtilityService
    ) {
        this.getCommunicationEventPurposeTypes();
    }

    ngOnInit(): void {}

    getCommunicationEventPurposeTypes() {
        this.communicationEventReportService.getCommunicationEventPurposeTypes().subscribe((res) => {
            if (res.communicationEventPurposeTypes) {
                this.communicationEventPurposeTypes = res.communicationEventPurposeTypes;
            }
        });
    }

    search() {
        if (this.checkValid() && (this.rAttending || this.rNotAttending)) {
            this.isLoading = true;
            this.msg = {};
            this.filter = '';

            this.communicationEventReportService.getCommunicationEventsReport(this.generatePayload()).subscribe({
                next: (res) => {
                    if (res.students) {
                        this.results = res.students.sort((n1: CommunicationEventReportResult, n2: CommunicationEventReportResult) =>
                            n1.PERSON?.LAST_NAME! > n2.PERSON?.LAST_NAME! ? 1 : -1
                        );

                        let prefixColumns: string[] = [];
                        this.displayedColumns = this.generateDisplayColumns(this.selectedSchoolYear, prefixColumns);
                    } else if (res.msg) {
                        this.results = [];
                        this.msg = res.msg;
                    } else {
                        this.results = [];
                        this.msg = { SUCCESS: false, MSG: 'Error retrieving Communication Events Report.' };
                    }
                },
                error: (err) => {
                    this.results = [];
                    this.msg = { SUCCESS: false, MSG: 'Error retrieving Communication Events Report.' };
                },
                complete: () => {
                    // Updates the Tables to be displayed w/ this.results
                    if (this.results.length > 0) {
                        this.updateDataSource();
                    }

                    // Display current performance period
                    this.currentSchoolYear = this.selectedSchoolYear;

                    // Display results
                    this.isLoading = false;
                }
            });
        } else {
            this.msg = { SUCCESS: false, MSG: 'Please select an Enrollment Type.' };
        }
    }

    generatePayload(): any {
        let payload: any = {};

        payload.chosenRegions = this.toNumberArray(this.chosenRegions);
        payload.chosenCounties = this.toNumberArray(this.chosenCounties);
        payload.chosenSchoolDistricts = this.toNumberArray(this.chosenSchoolDistricts);
        payload.chosenSchools = this.toNumberArray(this.chosenSchools);
        payload.schoolYear = this.selectedSchoolYear;

        payload.rAttending = this.rAttending;
        payload.rNotAttending = this.rNotAttending;
        payload.expiredEligibility = this.expiredEligibility;
        payload.expiredQAD = this.expiredQAD;
        payload.noCommunicationEvent = this.noCommunicationEvent;

        payload.gradeIDs = this.toNumberArray(this.grades);
        payload.communicationTypesIDs = this.toNumberArray(this.communicationTypes);

        return payload;
    }

    generateDisplayColumns(schoolYear: string, prefixColumns?: string[]) {
        let displayedColumns: string[] = prefixColumns ? prefixColumns : [];

        displayedColumns = displayedColumns.concat(this.baseDisplayedColumns);

        return displayedColumns;
    }

    updateDataSource() {
        setTimeout(() => {
            // Data
            this.tableDataSource = new MatTableDataSource<CommunicationEventReportResult>();
            this.tableDataSource.data = this.results;

            // Paginator
            this.tableDataSource.paginator = this.paginators.toArray()[0];

            // Sort
            this.tableDataSource.sort = this.sorts.toArray()[0];
            const defaultSort: Sort = { active: 'MSD_NUMBER', direction: 'asc' };
            this.tableDataSource.sort.active = defaultSort.active;
            this.tableDataSource.sort.direction = defaultSort.direction;
            this.tableDataSource.sort.sortChange.emit(defaultSort);
            this.tableDataSource.sortingDataAccessor = (obj, property) => this.getPropertyPipe.transform(obj, property, true);

            // Filter
            this.tableDataSource.filterPredicate = (data: any, filter) => {
                const dataStr = JSON.stringify(data).toLowerCase();
                return dataStr.indexOf(filter) != -1;
            };
        });
    }

    setFilter() {
        this.tableDataSource.filter = this.filter.trim().toLocaleLowerCase();
    }

    checkValid() {
        if (this.chosenRegions.length > 0 && this.selectedSchoolYear) {
            return true;
        }

        return false;
    }

    toNumberArray(array: any[]): number[] {
        let returnArray: number[] = [];

        array.forEach((obj) => {
            obj.ID ? returnArray.push(obj.ID) : null;
        });

        return returnArray;
    }

    performancePeriodEvent(performancePeriod: string) {
        this.selectedSchoolYear = performancePeriod;
    }

    // Filter Emiiters
    gradeEventEmitter(grades: Grade[]) {
        this.grades = grades;
    }

    communicationTypeEventEmitter(communicationTypes: CommunicationEventPurposeType[]) {
        this.communicationTypes = communicationTypes;
    }

    // MISC
    reset() {
        this.resetField = !this.resetField;
        //This is optional code To resetthe value after
        const s = timer(1000);
        s.subscribe((val) => {
            this.resetField = !this.resetField;
        });

        this.chosenRegions = [];
        this.chosenCounties = [];
        this.chosenSchoolDistricts = [];
        this.chosenSchools = [];

        this.rAttending = false;
        this.rNotAttending = false;
        this.expiredEligibility = true;
        this.expiredQAD = true;
        this.noCommunicationEvent = false;

        this.grades = [];
        this.communicationTypes = [];

        this.msg = {};
    }

    announceSortChange(sortState: Sort) {}

    isQadExpired(EoeDate: string) {
        if (moment(EoeDate).isValid()) {
            let expiredDay = new Date(moment(EoeDate).format('LL'));
            const today = new Date(moment().format('LL'));

            if (expiredDay < today) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    downloadExcel() {
        let payload = this.generateExportPayload('Excel');

        if (payload.data.length > 0) {
            this.isExporting = true;
            this.msg = new MsgModel();

            this.apiMsinExportsService.exportCommunicationEventsReport(payload).subscribe({
                next: (res2: any) => {
                    const blob = new Blob([res2], { type: 'application/xlsx' });

                    let fileName = this.utilityService.fnMakeFileNameTime('Communication_Events_Report');

                    const renamedFile = new File([blob], fileName, { type: blob.type, lastModified: Date.now() });

                    const url = URL.createObjectURL(renamedFile);

                    const a = document.createElement('a');
                    a.href = url;
                    fileName = fileName.trimLeft();

                    a.download = fileName + '.xlsx';
                    a.click();
                    if (a && a.parentNode === document.body) {
                        document.body.removeChild(a);
                    }

                    URL.revokeObjectURL(url);
                },
                error: (e) => {
                    this.msg = { SUCCESS: false, MSG: 'Error exporting Communication Events Report.' };
                    this.isExporting = false;
                },
                complete: () => {
                    this.isExporting = false;
                }
            });
        }
    }

    generateExportPayload(fileType: string) {
        let payload = {
            settings: {
                fileType: fileType
            },
            data: this.tableDataSource.data
        };

        return payload;
    }
}
